import { render } from "./RedeemButton.vue?vue&type=template&id=15e6b5c1&scoped=true"
import script from "./RedeemButton.vue?vue&type=script&lang=js"
export * from "./RedeemButton.vue?vue&type=script&lang=js"

import "./RedeemButton.vue?vue&type=style&index=0&id=15e6b5c1&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e6b5c1"]])

export default __exports__